import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as pdfjsLib from "pdfjs-dist/build/pdf";
import "pdfjs-dist/build/pdf.worker.entry";
import { usePdfStore } from "../store/usePdfStore";
import { ErrorSnackbar } from "../components/Snackbar/ErrorSnackbar";

const DocViewerPage = () => {
  const navigate = useNavigate();
  const pdfUrl = usePdfStore((state) => state.pdfUrl);
  const pdfPassword = usePdfStore((state) => state.pdfPassword);
  const docType = usePdfStore((state) => state.docType);
  const [numPages, setNumPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageContent, setPageContent] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (docType === "application/pdf") {
      const loadPage = async (pageNum) => {
        setIsLoading(true);
        try {
          const loadingTask = pdfjsLib.getDocument({ url: pdfUrl, password: pdfPassword });
          const pdf = await loadingTask.promise;
          setNumPages(pdf.numPages);

          const page = await pdf.getPage(pageNum);
          const viewport = page.getViewport({ scale: 1.5 });

          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");
          canvas.height = viewport.height;
          canvas.width = viewport.width;

          await page.render({ canvasContext: context, viewport }).promise;
          setPageContent(canvas.toDataURL());
        } catch (error) {
          setErrorMessage(error?.message || "Error al cargar el documento PDF");
          setShowError(true);
        } finally {
          setIsLoading(false);
        }
      };

      loadPage(currentPage);
    }
    setIsLoading(false);
  }, [pdfUrl, pdfPassword, currentPage, navigate, docType]);

  const goToPreviousPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const goToNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, numPages));
  };

  return (
    <>
      <div className="flex flex-col items-center p-4 select-none" style={{ userSelect: "none" }} onContextMenu={(e) => e.preventDefault()}>
        <h3 className="text-lg font-semibold mb-4">Documentos Asociados al cuestionario</h3>
        {numPages > 1 && (
          <div className="flex flex-col items-center mb-2">
            <div className="flex space-x-4 mb-2">
              <button
                onClick={goToPreviousPage}
                disabled={currentPage <= 1}
                className="px-3 py-1 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 disabled:bg-gray-200"
              >
                ← Anterior
              </button>
              <button
                onClick={goToNextPage}
                disabled={currentPage >= numPages}
                className="px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:bg-gray-200"
              >
                Siguiente →
              </button>
            </div>

            <div>
              Página: {currentPage} de {numPages}
            </div>
          </div>
        )}
        {isLoading ? (
          <p>Loading page {currentPage}...</p>
        ) : (
          <img
            src={docType === "application/pdf" ? pageContent : pdfUrl}
            alt={`Page ${currentPage}`}
            className="max-w-full mb-4 border rounded shadow"
            draggable={false}
          />
        )}
      </div>

      <ErrorSnackbar open={showError} onClose={() => setShowError(false)} title="Error" message={errorMessage} />
    </>
  );
};

export default DocViewerPage;
